import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'icon-toggle-open-close',
  templateUrl: './toggle-open-close.component.html',
  styleUrls: ['./toggle-open-close.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleOpenCloseComponent {
  @Input() public open: boolean = false;
}
